import { render, staticRenderFns } from "./ProductHistoryComponent.vue?vue&type=template&id=1e3edf56"
import script from "./ProductHistoryComponent.vue?vue&type=script&lang=js"
export * from "./ProductHistoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports